export class EditUserDto {
    globalId: string = '';
    name: string = '';
    department: string = '';
    role: string = '';
    email: string = '';
}